module.exports = __webpack_public_path__ + "canny-microsoft-teams-integration-86055e5e1058f689ebca042bcd2e545a.png";